module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "tag",
    attrs: {
      "id": "sdkPage"
    }
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [(!_vm.isDisable) ? _c('iframe', {
    attrs: {
      "width": "95%",
      "height": "615",
      "src": _vm.gitbookUrl,
      "frameborder": "0"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isDisable) ? _c('div', {
    staticStyle: {
      "width": "97.5%",
      "display": "flex",
      "justify-content": "center",
      "height": "760px",
      "background": "rgba(51, 51, 51, 0.1)"
    }
  }, [_c('div', {
    staticClass: "developer_documentation_download-copy"
  }, [_c('div', [_c('p', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v(_vm._s(_vm.$t('homePageFileDocumentationSdkNullTop')))]), _vm._v(" "), _c('img', {
    staticStyle: {
      "position": "relative",
      "bottom": "20px"
    },
    attrs: {
      "src": require("../../../static/img/sdk/sdk_motion_null.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('homePageFileDocumentationSdkNullBot')))])])]) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0dbc4221"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/sdkDescription.vue
// module id = 1462
// module chunks = 1